import { League } from '@/types/api.generated';
import { create } from 'zustand';

export const lobbyId = 'lobby';
export const promosId = 'promos';

export type TileType = 'lobby' | 'promos' | League;

export interface LobbySectionSelection {
    selectedTile: TileType;
    eventId: string | undefined;
    actions: {
        getSelectedTile: () => string;
        setSelectedTile: (league: TileType) => void;
        setEventId: (eventId: string) => void;
        clearEventId: () => void;
    };
}

export const useLobbySectionSelection = create<LobbySectionSelection>()((set, get) => ({
    selectedTile: lobbyId,
    eventId: undefined,
    actions: {
        setSelectedTile: (tile: TileType) => {
            set({ selectedTile: tile });
        },
        getSelectedTile: () => {
            return get().selectedTile;
        },
        setEventId: (eventId: string) => {
            set({ eventId });
        },
        clearEventId: () => {
            set({ eventId: undefined });
        },
    },
}));
